import { Box as MuiBox, BoxProps as MuiBoxProps, styled } from "@mui/material";
import { PropsWithChildren } from "react";

const AppMenuBox = styled(MuiBox)<MuiBoxProps>(({ theme }) => ({
    position: "absolute",
    width: theme.custom.width.menu,
    background: theme.custom.background.menu,
    top: 0,
    bottom: 0,
    left: 0,
    overflow: "auto",
    borderRadius: theme.custom.borderRadius.menu,
}));

type AppMenuProps = {};
const AppMenu = ({ children }: PropsWithChildren<AppMenuProps>) => {
    return <AppMenuBox>{children}</AppMenuBox>;
};

export default AppMenu;
